import { Link, useNavigate } from 'react-router-dom';
import logo from '@/assets/Logo.png';
import { routes } from '@/constants/routes';

const Header = ({ heading, paragraph, linkName, linkUrl = '#', useLogo = true, width, onLinkClick }) => {
	const navigate = useNavigate();

	const handleLinkClick = (e) => {
		if (onLinkClick) {
			e.preventDefault();
			onLinkClick();
		}
	};

	return (
		<div className="md:mb-6">
			{useLogo && (
				<button type="button" className="flex justify-center mx-auto" onClick={() => navigate(routes.home)}>
					<img src={logo} alt="logo" className={`w-${width ?? '[120px]'} md:w-[250px]`} />
				</button>
			)}

			<h2 className="text-center text-sm font-extrabold text-gray-900 md:mt-6 md:text-3xl">{heading}</h2>
			<p className="mt-2 text-center text-sm text-gray-600 flex flex-col gap-2 items-center md:flex-row md:justify-center">
				<span className="font-bold">{paragraph}</span>
				<Link 
					to={linkUrl} 
					className="transition duration-300 font-medium text-primary hover:text-primary/80"
					onClick={handleLinkClick}
				>
					{linkName}
				</Link>
			</p>
		</div>
	);
};

export default Header;
